import React from 'react';
import { Modal, Text, useResponsiveParams, Paper } from 'quanta-ui';
import {
  GET_DEFAULT_CLAUSES,
  GET_DEFAULT_CONDITIONS,
  GET_DEFAULT_EXCLUSIONS,
  GET_DEFAULT_WARRANTIES,
} from '../../queries';
// import Loading from '../../../../../../lib/layout/loading';
import { Loading } from 'quanta-flows/modules/layout';
// import Error from '../../../../../../lib/layout/error';
import { Error } from 'quanta-flows/modules/layout';
import { useQuery } from '@apollo/client';

export default function ModalViewDefault({
  setShowDefaultDetails,
  showViewDefault,
  productCode
}) {
  const {
    loading: loadingDefaultWarranties,
    error: errorDefaultWarranties,
    data: dataDefaultWarranties,
  } = useQuery(GET_DEFAULT_WARRANTIES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '4',
      },
    },
  });

  const {
    loading: loadingDefaultClauses,
    error: errorDefaultClauses,
    data: dataDefaultClauses,
  } = useQuery(GET_DEFAULT_CLAUSES, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '1',
      },
    },
  });

  const {
    loading: loadingDefaultConditions,
    error: errorDefaultConditions,
    data: dataDefaultConditions,
  } = useQuery(GET_DEFAULT_CONDITIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '2',
      },
    },
  });

  const {
    loading: loadingDefaultExclusions,
    error: errorDefaultExclusions,
    data: dataDefaultExclusions,
  } = useQuery(GET_DEFAULT_EXCLUSIONS, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        productCode,
        populateType: '3',
      },
    },
  });

  const screenType = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });

  const modalSize = useResponsiveParams({
    for_mobile: 'full',
    for_desktop: 'large',
    for_iPad: 'full',
  });

  if (
    loadingDefaultWarranties ||
    loadingDefaultClauses ||
    loadingDefaultConditions ||
    loadingDefaultExclusions
  ) {
    return (
      <div className="min-h-screen">
        <Loading />
      </div>
    );
  }

  if (
    errorDefaultWarranties ||
    errorDefaultClauses ||
    errorDefaultConditions ||
    errorDefaultExclusions
  ) {
    return (
      <Error
        error={
          errorDefaultWarranties ||
          errorDefaultClauses ||
          errorDefaultConditions ||
          errorDefaultExclusions
        }
      />
    );
  }

  const { getDefaultWarranties } = dataDefaultWarranties;
  const { getDefaultClauses } = dataDefaultClauses;
  const { getDefaultConditions } = dataDefaultConditions;
  const { getDefaultExclusions } = dataDefaultExclusions;

  const DisplayViewDefaultDetails = () => {
    return (
      <div>
        <div className="mt-2">
          {getDefaultClauses && getDefaultClauses?.length > 0 ? (
            <Paper>
              <Text type="title" className="font-semibold">
                <Text type="title" className="ml-1 mt-3">
                  Default Clauses
                </Text>
                <ul className="list-disc ml-6 mt-4 font-normal text-black">
                  {getDefaultClauses?.map((clause, idx) => (
                    clause?.default?.toString() === 'Y' ?
                    <li key={idx}>{clause?.clauseDescription}</li>
                    :''
                  ))}
                </ul>
              </Text>
            </Paper>
          ) : null}
        </div>
        <div className="mt-3">
          {getDefaultConditions &&
          getDefaultConditions?.length > 0 ? (
            <Paper>
              <Text type="title" className="font-semibold">
                <Text type="title" className="ml-1 mt-3">
                  Default Conditions
                </Text>
                <ul className="list-disc ml-6 mt-4 font-normal text-black">
                  {getDefaultConditions?.map((condition, idx) => (
                    condition?.txtDefault?.toString() === 'Y' ?
                    <li key={idx}>
                      {condition?.conditionShortDescription}
                    </li>
                    :''
                  ))}
                </ul>
              </Text>
            </Paper>
          ) : null}
        </div>
        <div className="mt-3">
          {getDefaultExclusions &&
          getDefaultExclusions?.length > 0 ? (
            <Paper>
              <Text type="title" className="font-semibold">
                <Text type="title" className="ml-1 mt-3">
                  Default Exclusions
                </Text>
                <ul className="list-disc ml-6 mt-4 font-normal text-black">
                  {getDefaultExclusions?.map((exclusion, idx) => (
                    exclusion?.txtDefault?.toString() === 'Y' ?
                    <li key={idx}>
                      {exclusion?.exclusionShortDescription}
                    </li>
                    :''
                  ))}
                </ul>
              </Text>
            </Paper>
          ) : null}
        </div>
        <div className="mt-3">
          {getDefaultWarranties &&
          getDefaultWarranties?.length > 0 ? (
            <Paper>
              <Text type="title" className="font-semibold">
                <Text type="title" className="ml-1 mt-3">
                  Default Warranties
                </Text>
                <ul className="list-disc ml-6 mt-4 font-normal text-black">
                  {getDefaultWarranties?.map((warranty, idx) => (
                    warranty?.txtDefault?.toString() === 'Y' ?
                    <li key={idx}>
                      {warranty?.warrantyShortDescription}
                    </li>
                    :''
                  ))}
                </ul>
              </Text>
            </Paper>
          ) : null}
        </div>
      </div>
    );
  };

  return (
    <Modal
      display={showViewDefault}
      size={modalSize}
      title={
        <Text
          severity={'info'}
          className={'font-semibold'}
          type={'large'}
        >
         Default Clauses,Conditions,Warranties And Exclusions
        </Text>
      }
      className={
        screenType?.toString()?.toLowerCase() === 'mobile'
          ? 'flex flex-col h-screen'
          : 'flex flex-col justify-between'
      }
      severity="info"
      onClose={() => {
        setShowDefaultDetails(false);
      }}
    >
      <DisplayViewDefaultDetails />
    </Modal>
  );
}
